<template>
  <div></div>
</template>

<script>
export default {
  name: 'judge',
  components: {},
  data () {
    return {}
  },
  mounted () {
    if (this.IsPC()) {
      this.$router.push({
        path: '/pc',
        query: {}
      })
    } else {
      this.$router.push({
        path: '/mob',
        query: {}
      })
    }
  },
  computed: {},
  methods: {
    IsPC () {
      var userAgentInfo = navigator.userAgent
      var Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod']
      var flagPc = true
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flagPc = false
          break
        }
      }
      return flagPc
    }
  }
}
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/views/frontent/judge.vue